import { isRedSuit } from '../game/engine.js';

export function Card({ card, faceDown, size = 'md' }) {
  const sizes = {
    sm: 'w-12 h-16 text-base',
    md: 'w-20 h-32 text-2xl',
    lg: 'w-24 h-40 text-3xl',
  };
  if (faceDown) return <div className={`card-back ${sizes[size]}`} />;
  const red = isRedSuit(card);
  return (
    <div className={`card-face ${sizes[size]} flex flex-col items-center justify-center font-bold ${red ? 'text-red-600' : 'text-black'}`}>
      <div>{card.rank}</div>
      <div className="text-3xl leading-none">{card.suit}</div>
    </div>
  );
}

export function Hand({ cards, hideSecond = false, size = 'md' }) {
  if (!cards.length) {
    return <div className="h-32 w-24 border-2 border-dashed border-white/20 rounded-lg" />;
  }
  return (
    <div className="flex gap-2">
      {cards.map((c, i) => (
        <Card key={i} card={c} faceDown={hideSecond && i === 1} size={size} />
      ))}
    </div>
  );
}
